export const handlePending = (state) => {
  state.error = null;
  state.isLoading = true;
};

export const handleReject = (state, { payload }) => {
  state.error = payload;
  state.isLoading = false;
};

export const handleProductsFulfilled = (state, { payload }) => {
  state.products = payload;
  state.error = null;
  state.isLoading = false;
};

export const handleCategoriesFulfilled = (state, { payload }) => {
  state.categories = payload;
  state.error = null;
  state.isLoading = false;
};
